import {h, Component} from 'preact';
import cx from 'classnames';
import {mapRootUrl} from '@util/URLUtils';
import isEmptyOrNil from '@util/fn/isEmptyOrNil';
import DropMenu from './DropMenu';
import {dropMenu} from './styles';
import NavItem from './NavItem';
import ResizeSensor from 'css-element-queries/src/ResizeSensor';

const AllProductsMenu = ( {title, secondaryTitle, url, sysId, children, isFormulary} ) =>
    <NavItem title={title} url={url}>
        <DropMenu menuId={sysId} className={cx( dropMenu.primaryMenu, {'nav-drop-menu--formulary': isFormulary} )}>
            < DropMenu.nav menuItems={children.map( mapRootUrl( {url: url} ) )}/>
        </DropMenu>
    </NavItem>;

class PrimaryNav extends Component {
    componentDidMount() {
        this.menuItems = this.navEl.querySelectorAll( 'li[data-menu-trigger]' );

        this.toggleVisibleMenuItems();
        new ResizeSensor( this.navEl, () => this.toggleVisibleMenuItems() );
    }

    toggleVisibleMenuItems() {
        let aggWidth = 0;
        const baseWidth = this.navEl.offsetWidth;

        [...this.menuItems].forEach( node => {
            node.style.display = 'block';
            aggWidth += node.getBoundingClientRect().width;
            node.style.display = (aggWidth < baseWidth) ? 'block' : 'none';
        } );
    }

    render( {taxonomy}, state, context ) {
        let allItemsMenu = null;
        let primaryNavList = taxonomy;
        let NavComponent = DropMenu.nav;

        // if "Shopping: tab selected then root taxonomy to the "Products" tier of this taxonomy level
        if ( context.isShoppingTaxonomy ) {
            // will be either "formulary" or "all products"
            allItemsMenu = mapRootUrl( taxonomy )( taxonomy.children[0] );
            primaryNavList = context.hasFormulary
                ? mapRootUrl( taxonomy )( taxonomy.children[1] )
                : Object.assign( {}, allItemsMenu );

            NavComponent = DropMenu.megaMenu;
        }

        return (
            <ul ref={ref => this.navEl = ref}
                className="nav-group-primary list-reset w-full flex flex-wrap flex-1 text-base m-0 leading-none pl-4">

                {allItemsMenu &&
                <AllProductsMenu {...allItemsMenu} isFormulary={context.hasFormulary}/>
                }

                {primaryNavList.children
                    .map( mapRootUrl( primaryNavList ) )
                    .map( ( {title, cssClass, url, children} ) => {
                            if ( !isEmptyOrNil( children ) ) {
                                return (
                                    <NavItem title={title} url={url}>
                                        <DropMenu className={cx( cssClass, {
                                            [dropMenu.megaMenu]: context.isShoppingTaxonomy,
                                            [dropMenu.primaryMenu]: !context.isShoppingTaxonomy
                                        } )}>
                                            <NavComponent menuItems={children.map( mapRootUrl( {url} ) )}/>
                                        </DropMenu>
                                    </NavItem>
                                )
                            }
                            else {
                                return <NavItem title={title} url={url}/>
                            }
                        }
                    )}
            </ul>
        );
    }
}

export default PrimaryNav;
